import { useState, useEffect, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getAllPsadReps } from 'api/psad_reps';

import Loading from 'components/loading/loading';

const PsadReps = () => {
  const [loading, setLoading] = useState(false);
  const [psadReps, setPsadReps] = useState([]);
  const history = useHistory();

  const getData = useCallback(async () => {
    setLoading(true);
    const psadReps = await getAllPsadReps();
    setPsadReps(psadReps);
    setLoading(false);
  }, []);

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [getData]);

  if (loading) return <Loading />;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header members-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <Link to="/psad_reps" className="active">
              PSAD representatives
            </Link>
          </h2>

          <section className="view-actions">
            <button
              className="btn-green"
              data-cy="submit"
              onClick={() => history.push('/psad_reps/add')}
            >
              Add representative
            </button>
          </section>
        </header>

        <section className="view-container">
          <section className="content-list">
            <ol className="members-list th-list">
              <li className="th-list-row header">
                <div className="th-filter-header" id="th-filter-header">
                  <div className="th-filter-header-label">Representative</div>
                </div>
                <div className="th-select-header nowrap">
                  <div className="th-select-header-label">
                    Treating Organization
                  </div>
                </div>
              </li>
              {psadReps.map((d) => (
                <li
                  key={d.id}
                  className="th-list-row th-members-list-item pointer"
                  onClick={() => history.push(`/psad_reps/${d.id}`)}
                >
                  <div className="th-list-data th-members-list-basic">
                    <div className="flex items-center">
                      <div>
                        <h3 className="ma0 pa0 th-members-list-name ">
                          {d.firstName} {d.lastName}
                        </h3>
                        <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                          <span>{d.email}</span>
                        </p>
                        <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                          <span>{d.phone}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="th-list-data middarkgrey f8">
                    <span className="midlightgrey">{d.treatingOrg?.name}</span>
                  </div>
                </li>
              ))}
            </ol>
          </section>
        </section>
      </section>
    </main>
  );
};

export default PsadReps;
